































































import { Component, Prop, Watch } from "vue-property-decorator";
import ProductService from "@/services/product_service";
import UserService from "@/services/user_service";
import { mixins } from "vue-class-component";
import { Auth } from "@/mixins/auth";

@Component
export default class Share extends mixins(Auth) {
  @Prop({ default: false }) showDialog!: boolean;
  @Prop() shareLink!: string;
  @Prop() configShortCode!: string;
  protected productService = new ProductService();
  protected userService = new UserService();
  protected show = false;
  protected copied = false;
  protected emailed = false;
  protected shareEmails = "";
  protected showEmailWarning = false;

  @Watch("showDialog", { immediate: true })
  protected isOpen(): void {
    this.show = this.showDialog;
    this.copied = false;
    this.emailed = false;
    this.showEmailWarning = false;
    this.shareEmails = "";
    console.log('Share modal opening, configShortCode:', this.configShortCode);
  }

  @Watch("configShortCode", { immediate: true })
  protected onCodeChange(): void {
    console.log('configShortCode changed to:', this.configShortCode);
  }

  protected closeDialog(): void {
    this.show = false;
    this.$emit('close');
  }

  protected copy(identifier: "linkElement" | "shortCode"): void {
    this.copied = false;
    const element = (identifier === "linkElement"
      ? this.$refs.linkElement
      : this.$refs.shortCode) as HTMLElement;
    
    // Create a range and select the text content
    const range = document.createRange();
    range.selectNodeContents(element);
    const selection = window.getSelection();
    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand("copy");
      selection.removeAllRanges();
    }
    this.copied = true;
  }

  protected async sendEmail(): Promise<void> {
    if (this.shareEmails === '') {
      this.showEmailWarning = true;
    } else {
      this.emailed = false;
      this.showEmailWarning = false;
      if (this.user) {
        this.emailed = await this.productService.shareShadeDesign(
          this.shareLink,
          this.shareEmails,
          this.user
        );
      }
    }
  }
}
